import type { Right } from "@/services/user";
import { type User } from "@/services/user";
import { readonly } from "vue";

const user = ref<User>();

export function useUser() {
  const hasRight = (right: Right): boolean => {
    return user.value?.rights.includes(right) ?? false;
  };

  const isUserLoggedIn = computed(() => user.value !== undefined);

  return {
    user,

    hasRight,
    isUserLoggedIn: readonly(isUserLoggedIn),
  };
}
